"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorBoundaryContents = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
// import { HomeIcon, RefreshIcon, SadIcon } from '@/app/styling/icons'
const styled_components_1 = __importDefault(require("styled-components"));
const elements_1 = require("@src/components/elements");
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const icons_1 = require("@ant-design/icons");
const useConfig_1 = require("@src/hooks/useConfig");
const ErrorBoundaryContents = ({ error, timestamp }) => {
    const config = (0, useConfig_1.useConfig)();
    const handleHome = () => {
        window.location.href = '/';
    };
    const handleRefresh = () => {
        window.location.reload();
    };
    return ((0, jsx_runtime_1.jsxs)(elements_1.Modal, { closable: false, visible: true, title: (0, jsx_runtime_1.jsxs)("div", { className: "flex-row align-center", children: [(0, jsx_runtime_1.jsx)("span", { className: "m-r-s", children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "general.something_went_wrong" }) }), (0, jsx_runtime_1.jsx)(icons_1.FrownOutlined, {})] }), footer: (0, jsx_runtime_1.jsxs)(Actions, { children: [(0, jsx_runtime_1.jsxs)(elements_1.Button, { size: "middle", onClick: handleHome, children: [(0, jsx_runtime_1.jsx)(icons_1.HomeOutlined, { className: "m-r-s" }), (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "general.home" })] }), (0, jsx_runtime_1.jsxs)(elements_1.Button, { type: "default", size: "middle", onClick: handleRefresh, children: [(0, jsx_runtime_1.jsx)(icons_1.RedoOutlined, { className: "m-r-s" }), (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "general.refresh" })] })] }), children: [(0, jsx_runtime_1.jsx)(Desc, { children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "error.support" }) }), (0, jsx_runtime_1.jsx)("a", { href: `mailto:${config.supportEmail}`, children: (0, jsx_runtime_1.jsxs)(elements_1.Button, { type: "default", size: "middle", children: [(0, jsx_runtime_1.jsx)(icons_1.MailOutlined, { className: "m-r-s" }), (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "general.support" })] }) }), (0, jsx_runtime_1.jsx)("div", { className: "m-t-l m-b-s", children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "error.info_for_support" }) }), (0, jsx_runtime_1.jsxs)(Items, { children: [(0, jsx_runtime_1.jsx)(ItemTitle, { children: "Time" }), (0, jsx_runtime_1.jsx)(ItemValue, { children: timestamp && timestamp.toISOString() }), (0, jsx_runtime_1.jsx)(ItemTitle, { children: "Environment" }), (0, jsx_runtime_1.jsx)(ItemValue, { children: navigator.userAgent }), (0, jsx_runtime_1.jsx)(ItemTitle, { children: "Error message" }), (0, jsx_runtime_1.jsx)(ItemValue, { children: error.message }), (0, jsx_runtime_1.jsx)(ItemTitle, { children: "Error stack" }), (0, jsx_runtime_1.jsx)(ItemValue, { children: (0, jsx_runtime_1.jsx)("pre", { children: error.stack }) })] })] }));
};
exports.ErrorBoundaryContents = ErrorBoundaryContents;
const Desc = styled_components_1.default.div `
	margin-bottom: 1rem;
`;
const Items = styled_components_1.default.div `
	font-size: 10px;
`;
const ItemTitle = styled_components_1.default.div `
	color: #aaa;
`;
const ItemValue = styled_components_1.default.div `
	overflow-x: auto;
	margin-bottom: 0.2rem;
	padding-bottom: 0.1rem;

	pre {
		margin: 0;
		font-size: 10px;
	}
`;
const Actions = styled_components_1.default.div `
	flex-grow: 0;
	margin-left: auto;
	display: flex;

	> button {
		margin-left: 0.5rem;
	}
`;
